export default __webpack_public_path__ + "d155fd12b36d27627662f4c9f0b7f8dd.png";